function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
//Limitless imports
import { PortalTextInput } from "@limitless/portal";
const CheckTextField = ({
  check,
  onChange,
  readOnly,
  ...rest
}) => {
  const {
    value,
    id,
    isInvalid = false
  } = check;
  const location = useLocation();

  // Check if we are on the "onboarding/detail" page
  const isOnOnboardingDetailPage = location.pathname === "/onboarding/detail";
  React.useEffect(() => {
    if (!readOnly) {
      onChange(value);
    }
  }, []);
  const handleChange = e => {
    const newValue = e.target.value;
    onChange(newValue);
  };
  return /*#__PURE__*/React.createElement(PortalTextInput, _extends({
    id: id,
    label: "",
    onChange: handleChange,
    value: value,
    fullWidth: true,
    helperText: isInvalid ? "Must be 20 characters or less" : null,
    showHelperText: true,
    disabled: readOnly
  }, rest, {
    sx: isOnOnboardingDetailPage ? {
      "& .MuiOutlinedInput-root": {
        padding: 0
      }
    } : {}
  }));
};
export default CheckTextField;
CheckTextField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};